<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ujJA6/tc-custom/9781620066539.jpg?1705766125074" alt="This image is the cover for the book Devil Tree II"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Devil Tree II
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Darkness reigns under the shadow of an ancient oak tree in this grisly thriller inspired by horrific crimes—and a haunting legend—in Port St. Lucie, Florida . . .</b><br/><br/> Convicted killer Gerard John Schaefer wreaked havoc along the Treasure Coast and Hutchinson Island in the 1970s. His reign of terror included unspeakable acts of torture, rape, and murder in the shadow of an ancient oak tree. He hanged people there, buried their bodies, and came back often to pillage what remained. It is believed that Schaefer’s evil seeped into the tree and surrounding area, leaving a blemish on the otherwise beautiful nature walk in Oak Hammock Park. When night descends around the tree, the atmosphere changes completely; hundreds of stories are offered up about personal experiences of a true-life haunting . . .<br/><br/> This follow-up to <i>The Devil Tree</i> follows the legend into the present day, as Satanists commune by the tree in honor of their fallen idol. Terrible things happen around the tree, which seems to have a certain allure to it . . . making people commit unimaginable acts. What drives someone to kill? Is it something within them, or an outside force that influences them?<br/><br/> This sick and grisly legend is so deep, so convoluted and wicked, you won’t believe what you read. Whatever you do, don’t visit the Devil Tree after dusk. You will never be the same. That is the warning of many people—including uniformed officers who have come forth to share their experiences at the tree . . . </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Keith Rommel
      </h2>
      
      <p class="authorDescription body article">Keith Rommel is a multi-award-winning author and screenwriter best known for his Thanatology dark suspense series, The Devil Tree series based on a notoriously haunted location in Florida, and the fast-paced Cultures Collide crime series. Rommel&rsquo;s stories have been called &ldquo;intelligent fiction&rdquo; and &ldquo;horror for the curious mind.&rdquo; Keith has had the honor of co-writing <I>The Cursed Man</I> and<I> The Lurking Man</I> movies which have garnished more than 160 awards combined, including best screenplays and best feature films. All of his novels are available at all major booksellers and both films are available on most major platforms. www.keithrommel.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sunbury Press, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78b9eb90